import React from 'react';
import {
  Box,
  LinearProgress,
  LinearProgressProps,
  Typography
} from '@material-ui/core';
import { roundDigit } from './viewer/js/misc';

// TODO: replace other linear progress with label with this (might need extra customization)

export const LinearProgressWithLabel = (props: LinearProgressProps & { value: number }) => {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35} style={{textAlign: "right"}}>
        <Typography variant="body2" color="textSecondary">
          {`${roundDigit(props.value, 2)}%`}
        </Typography>
      </Box>
    </Box>
  );
};
